/* eslint-disable no-param-reassign */
import type { StandardChartLayerSpec } from '../../../../core/layer';
import type { Spec as ChainChangeBarLayerSpec } from '../../../../layer/preset/bar/chainChangeBar';
import {
  BaseSpec,
  ILayerTypeSpec,
  createDataTypeValidator,
  createEncodingValidator,
  createLayerProcessor
} from '../baseProcessor';

export type Spec = BaseSpec;

// 扩展ILayerTypeSpec以包含__isEncodingValid属性
interface ChainChangeBarLayerTypeWithFields extends ILayerTypeSpec {
  __isEncodingValid?: boolean;
}

type ChainChangeBarLayerType = StandardChartLayerSpec &
  ChainChangeBarLayerSpec &
  ChainChangeBarLayerTypeWithFields;

// 创建环比变化柱状图数据类型验证器
const validateChainChangeBarDataTypes = createDataTypeValidator('chainChangeBar', [
  { field: 'x', type: 'string' },
  { field: 'y', type: 'number' },
  { field: 'y1', type: 'number' }
]);

// 创建环比变化柱状图编码验证器
const validateChainChangeBarEncoding = createEncodingValidator([
  { field: 'x' },
  { field: 'y' },
  { field: 'y1' }
]);

// 创建并导出环比变化柱状图处理器
export const chainChangeBar = createLayerProcessor<ChainChangeBarLayerType>(
  'chainChangeBar',
  validateChainChangeBarEncoding,
  validateChainChangeBarDataTypes
);
